import { Flex } from '@chakra-ui/react';
import { NavigationContext as NavigationContextValue } from '@bridge/navigationStore';
import { useTranslation } from 'react-i18next';
import { ArticleContextNavigation } from './ArticleContextNavigation';
import { ConceptContextNavigation } from './ConceptContextNavigation';
import { CustomerContextNavigation } from './CustomerContextNavigation';

interface ContextNavigationProps {
  activeState: string;
  context: NavigationContextValue;
}

export function ContextNavigation({
  activeState,
  context,
}: ContextNavigationProps) {
  const { t } = useTranslation();

  return (
    <Flex
      as="nav"
      aria-label={t('navigation.currentItem')}
      direction="column"
      flexShrink={0}
      w="252px"
      h="100dvh"
      px="3"
      py="3"
      bg="navigation.contextBackground"
      borderRightWidth="1px"
      borderRightColor="navigation.contextBorder"
      overflowY="auto"
    >
      {context.type === 'customer' && (
        <CustomerContextNavigation
          activeState={activeState}
          context={context}
        />
      )}
      {context.type === 'concept' && (
        <ConceptContextNavigation activeState={activeState} context={context} />
      )}
      {context.type === 'article' && (
        <ArticleContextNavigation activeState={activeState} context={context} />
      )}
    </Flex>
  );
}
